module.exports = __webpack_public_path__ + "media/stylesheets/images/mypage/right-arrow-bd92e5790b70c1ad24d376505b06fb35.png";